import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Table, Typography } from 'antd'
import { formatRate } from './utils'

// The API asks for confirmation when a rate moves by more than 10% (a typo like 113 for 11.3).
const ConfirmChanges = ({ items, labels, onConfirm, onCancel, saving }) => (
  <Modal
    title="Are you sure?"
    open={items.length > 0}
    okText="Save anyway"
    cancelText="Go back"
    okButtonProps={{ danger: true, loading: saving }}
    onOk={onConfirm}
    onCancel={onCancel}
    centered
  >
    <Typography.Paragraph>
      These rates moved by more than 10%. Check them before saving.
    </Typography.Paragraph>
    <Table
      rowKey="field"
      size="small"
      pagination={false}
      dataSource={items}
      columns={[
        { title: 'Rate', dataIndex: 'field', render: field => labels[field] || field },
        { title: 'Was', dataIndex: 'old', render: formatRate },
        { title: 'Now', dataIndex: 'new', render: formatRate },
        {
          title: 'Change',
          dataIndex: 'changePercent',
          render: value => `${Number(value) > 0 ? '+' : ''}${value}%`
        }
      ]}
    />
  </Modal>
)

ConfirmChanges.propTypes = {
  items: PropTypes.array.isRequired,
  labels: PropTypes.object,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  saving: PropTypes.bool
}

ConfirmChanges.defaultProps = { labels: {}, saving: false }

export default ConfirmChanges
